import { defaultFilterKeys, filterObjectKeys } from '../utils';

import { createFullStoryPlugin as myAsurionCreateFullStoryPlugin } from '@soluto-private/myasurion-analytics';

const transform = (props: any) => filterObjectKeys(props, defaultFilterKeys);

const createFullStoryPlugin = () => myAsurionCreateFullStoryPlugin(transform);

export default createFullStoryPlugin;
